// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".explorer-toolbar a[data-v-64dc7f9c] {\n  display: flex;\n  color: currentColor;\n}\n.explorer-toolbar a .logo[data-v-64dc7f9c] {\n  height: 40px;\n  width: auto;\n}\n.theme--light.explorer-toolbar[data-v-64dc7f9c] {\n  background-color: #eeeeee;\n}\n.theme--dark.explorer-toolbar[data-v-64dc7f9c] {\n  background-color: #1c1e22;\n}", ""]);
// Exports
module.exports = exports;
